import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {SpModalProjectListFolderCreateComponent} from '../sp-modal-project-list-folder-create/sp-modal-project-list-folder-create.component';
import {MatDialog} from '@angular/material/dialog';
import {Project} from '../../../../models/project';
import {UntypedFormControl} from '@angular/forms';
import {environment} from '../../../../../environments/environment';
import {AlertService} from '../../../../services/sp-alert/alert.service';
import {AnyFolder, ProjectManagerService} from '../../../../services/sp-project/project-manager.service';
import {FolderActionsService} from '../../../../services/sp-folder/folder-actions.service';

@Component({
  selector: 'app-sp-modal-project-list-add-to-folder',
  templateUrl: './sp-modal-project-list-add-to-folder.component.html',
  styleUrls: ['./sp-modal-project-list-add-to-folder.component.scss']
})
export class SpModalProjectListAddToFolderComponent implements OnInit {

  selected: AnyFolder = null;
  folders: AnyFolder[];
  folderInputControl = new UntypedFormControl();

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<SpModalProjectListFolderCreateComponent>,
    private alert: AlertService,
    @Inject(MAT_DIALOG_DATA) private data: {project: Project, folders: AnyFolder[]},
    private folderActions: FolderActionsService,
    private projectManager: ProjectManagerService) {
    this.folders = data.folders;
  }

  ngOnInit() {}

  /** Adds the project to `folder`, moving it out of the opened folder if it is there. Any folder, wherever it is kept. */
  async addToFolder(folder: AnyFolder) {
    const actualFolder = this.projectManager.openedFolder;
    try {
      if (actualFolder && actualFolder.projects.some((p: {id: number}) => p.id == this.data.project.id)) {
        await this.folderActions.removeProject(actualFolder, this.data.project);
      }
      await this.folderActions.addProject(folder, this.data.project);
      this.projectManager.removeLocalProject(this.data.project);
    } finally {
      this.dialogRef.close();
    }
  }

  filteredFolders(): AnyFolder[] {
    let filtered = this.data.folders;

    if (this.projectManager.openedFolder) {
      filtered = this.data.folders.filter(f => f.id !== this.projectManager.openedFolder.id);
    }

    return filtered.filter(f => this.selected ? f.id !== this.selected.id : true);
  }

  async createFolder() {
    const name = this.folderInputControl.value;

    if (name && name !== '') {
      const folder = await this.folderActions.createFolder(name);
      this.folders.push(folder);
      await this.addToFolder(folder);
    }
  }

  buildFolderName(folder: AnyFolder){
    if (!folder) return '';
    const datePart = `(${new Date(folder.created_at).toISOString().split('T')[0]})`;
    return folder.flag != null ? folder.name + ' ' + datePart : folder.name;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
